export enum CONTEXT_MENU_ID {
  FOR_RNA = 'context-menu-for-RNA',
  FOR_SEQUENCE = 'context-menu-for-sequence',
  FOR_POLYMER_BOND = 'context-menu-for-polymer-bond',
  FOR_SELECTED_MONOMERS = 'context-menu-for-selected-monomers',
}
